import CircleUserRoundSvg from '@assets/images/svg/circle-user-round.svg';
import React from 'react';
import { View } from 'react-native';

export interface CircleUserRoundIconProps {
    size?: number;
    color?: string;
}

export function CircleUserRoundIcon({ size = 103, color = '#333333' }: CircleUserRoundIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CircleUserRoundSvg width={size} height={size} color={color} />
        </View>
    );
}


